/** Kateqoriyaya görə dinamik xüsusiyyət sahələri (Lalafo üslubu). */

export type SpecField = {
  name: string;
  label: string;
  type: "select" | "text" | "number" | "file" | "textarea";
  options?: string[];
  /** Yalnız bu sahənin dəyərindən asılı olaraq variantlar dəyişir */
  dependsOn?: string;
  optionsBy?: Record<string, string[]>;
  placeholder?: string;
  suffix?: string;
  /** Yalnız başqa sahə bu dəyəri alanda göstərilir */
  showWhen?: { field: string; value: string };
  /** Fayl sahəsi üçün qəbul olunan formatlar */
  accept?: string;
  /** Formada tam en tutsun */
  full?: boolean;
};

/** Ümumi məhsul vəziyyətləri. */
const conditions = ["Yeni", "İdeal vəziyyətdə", "Az işlənmiş", "İşlənmiş", "Təmir tələb edir"];

/** Nəqliyyat üçün vəziyyət seçimləri. */
const vehicleConditions = ["Yeni", "İdeal vəziyyətdə", "Az işlənmiş", "İşlənmiş", "Qəzalı / Təmir tələb edir"];

export const phoneModels: Record<string, string[]> = {
  Apple: [
    "iPhone 16 Pro Max", "iPhone 16 Pro", "iPhone 16 Plus", "iPhone 16", "iPhone 16e",
    "iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15 Plus", "iPhone 15",
    "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14 Plus", "iPhone 14",
    "iPhone 13 Pro Max", "iPhone 13 Pro", "iPhone 13", "iPhone 13 mini",
    "iPhone 12 Pro Max", "iPhone 12 Pro", "iPhone 12", "iPhone 12 mini",
    "iPhone SE (2022)", "iPhone SE (2020)",
    "iPhone 11 Pro Max", "iPhone 11 Pro", "iPhone 11",
    "iPhone XS Max", "iPhone XS", "iPhone XR", "iPhone X",
    "iPhone 8 Plus", "iPhone 8", "iPhone 7 Plus", "iPhone 7", "Digər",
  ],
  Samsung: [
    "Galaxy S25 Ultra", "Galaxy S25+", "Galaxy S25",
    "Galaxy S24 Ultra", "Galaxy S24+", "Galaxy S24", "Galaxy S24 FE",
    "Galaxy S23 Ultra", "Galaxy S23+", "Galaxy S23", "Galaxy S23 FE",
    "Galaxy S22 Ultra", "Galaxy S22+", "Galaxy S22", "Galaxy S21", "Galaxy S20",
    "Galaxy Z Fold 6", "Galaxy Z Fold 5", "Galaxy Z Flip 6", "Galaxy Z Flip 5",
    "Galaxy A56", "Galaxy A55", "Galaxy A54", "Galaxy A36", "Galaxy A35", "Galaxy A34",
    "Galaxy A25", "Galaxy A24", "Galaxy A16", "Galaxy A15", "Galaxy A14", "Galaxy A13",
    "Galaxy A06", "Galaxy A05", "Galaxy A04", "Galaxy A03",
    "Galaxy M34", "Galaxy M14", "Galaxy Note 20 Ultra", "Galaxy Note 20", "Galaxy Note 10", "Digər",
  ],
  Xiaomi: [
    "14 Ultra", "14T Pro", "14T", "14", "13 Pro", "13", "12", "11",
    "Redmi Note 14 Pro+", "Redmi Note 14 Pro", "Redmi Note 14",
    "Redmi Note 13 Pro+", "Redmi Note 13 Pro", "Redmi Note 13",
    "Redmi Note 12 Pro", "Redmi Note 12", "Redmi Note 11",
    "Redmi 14C", "Redmi 13C", "Redmi 12", "Redmi 10", "Redmi 9",
    "Poco X7 Pro", "Poco X6 Pro", "Poco X5", "Poco F6", "Poco F5", "Poco M6", "Digər",
  ],
  Huawei: [
    "Mate 60 Pro", "Mate 50 Pro", "Mate 50", "Mate 40 Pro",
    "P60 Pro", "P50 Pro", "P50", "P40 Pro", "P40 lite", "P30 Pro", "P30",
    "Nova 13", "Nova 12", "Nova 11", "Nova 10", "Nova 9", "Y9", "Y7", "Digər",
  ],
  Honor: [
    "Magic 7 Pro", "Magic 6 Pro", "Magic 6", "Magic 5",
    "200 Pro", "200", "90", "90 Lite", "70",
    "X9c", "X9b", "X8b", "X8", "X7", "X6", "Digər",
  ],
  Realme: [
    "13 Pro+", "13 Pro", "12 Pro+", "12 Pro", "12", "11 Pro", "11",
    "C67", "C55", "C53", "C33", "Note 60", "Note 50", "GT 6", "GT Neo 5", "Digər",
  ],
  Oppo: [
    "Find X8 Pro", "Find X7", "Find X5", "Reno 12 Pro", "Reno 12", "Reno 11", "Reno 10",
    "Reno 8", "A98", "A78", "A60", "A58", "A38", "A18", "A17", "Digər",
  ],
  Vivo: [
    "X100 Pro", "X100", "X90", "V40", "V30", "V29", "V27",
    "Y100", "Y36", "Y28", "Y27", "Y22", "Y17", "Digər",
  ],
  Nokia: ["G42", "G22", "C32", "C22", "C21", "105", "110", "3310", "8210 4G", "Digər"],
  Google: ["Pixel 9 Pro XL", "Pixel 9 Pro", "Pixel 9", "Pixel 8 Pro", "Pixel 8", "Pixel 7a", "Pixel 7", "Pixel 6", "Digər"],
  OnePlus: ["12", "11", "10 Pro", "Nord 4", "Nord 3", "Nord CE 4", "Digər"],
  Infinix: ["Note 40 Pro", "Note 30", "Hot 50", "Hot 40", "Smart 8", "Zero 30", "Digər"],
  Tecno: ["Camon 30", "Camon 20", "Spark 20", "Spark 10", "Pova 6", "Digər"],
  ZTE: ["Blade A73", "Blade V50", "Nubia Z60", "Nubia Neo 2", "Digər"],
  Motorola: ["Edge 50", "Edge 40", "G84", "G54", "G24", "Razr 40", "Digər"],
  Digər: ["Digər"],
};

export const carModels: Record<string, string[]> = {
  Mercedes: ["C 180", "C 200", "E 200", "E 220", "S 500", "GLE", "ML 350", "Vito", "Digər"],
  BMW: ["320", "328", "520", "530", "X3", "X5", "X6", "Digər"],
  Toyota: ["Corolla", "Camry", "Prado", "RAV4", "Prius", "Land Cruiser", "Digər"],
  Hyundai: ["Elantra", "Sonata", "Tucson", "Accent", "Santa Fe", "Digər"],
  Kia: ["Rio", "Optima", "Sportage", "Cerato", "K5", "Digər"],
  LADA: ["Priora", "Vesta", "Granta", "Niva", "2107", "Digər"],
  Chevrolet: ["Cruze", "Malibu", "Captiva", "Cobalt", "Digər"],
  Nissan: ["Qashqai", "X-Trail", "Sunny", "Patrol", "Digər"],
  Volkswagen: ["Passat", "Golf", "Polo", "Touareg", "Jetta", "Digər"],
  Opel: ["Astra", "Vectra", "Zafira", "Digər"],
  Ford: ["Focus", "Fusion", "Transit", "Digər"],
  Audi: ["A4", "A6", "Q5", "Q7", "Digər"],
  Digər: ["Digər"],
};

const years = Array.from({ length: 46 }, (_, i) => String(new Date().getFullYear() - i));

const phoneFields: SpecField[] = [
  { name: "brand", label: "Marka", type: "select", options: Object.keys(phoneModels) },
  { name: "model", label: "Model", type: "select", dependsOn: "brand", optionsBy: phoneModels },
  { name: "memory", label: "Yaddaş", type: "select", options: ["16 GB", "32 GB", "64 GB", "128 GB", "256 GB", "512 GB", "1 TB"] },
  { name: "color", label: "Rəng", type: "select", options: ["Qara", "Ağ", "Boz", "Gümüşü", "Qızılı", "Mavi", "Yaşıl", "Qırmızı", "Bənövşəyi", "Çəhrayı", "Digər"] },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

const realtyFields: SpecField[] = [
  { name: "property_type", label: "Əmlakın növü", type: "select", options: ["Mənzil", "Həyət evi / Villa", "Bağ evi", "Ofis", "Obyekt", "Torpaq"] },
  { name: "deal_type", label: "Elanın növü", type: "select", options: ["Satılır", "Alınır", "Kirayə (aylıq)", "Kirayə (günlük)", "Kirayə götürülür"] },
  { name: "rooms", label: "Otaq sayı", type: "select", options: ["1", "2", "3", "4", "5", "6+"] },
  { name: "floor", label: "Mərtəbə", type: "text", placeholder: "Məs: 5/9" },
  { name: "area", label: "Sahə", type: "number", placeholder: "Məs: 85", suffix: "m²" },
  { name: "document", label: "Sənəd", type: "select", options: ["Kupça (çıxarış)", "Müqavilə", "Sərəncam", "Sənədsiz"] },
  { name: "repair", label: "Təmir", type: "select", options: ["Təmirli", "Təmirsiz", "Əla təmir"] },
];

const carFields: SpecField[] = [
  { name: "make", label: "Marka", type: "select", options: Object.keys(carModels) },
  { name: "model", label: "Model", type: "select", dependsOn: "make", optionsBy: carModels },
  { name: "year", label: "Buraxılış ili", type: "select", options: years },
  { name: "mileage", label: "Yürüş", type: "number", placeholder: "Məs: 145000", suffix: "km" },
  { name: "fuel", label: "Yanacaq növü", type: "select", options: ["Benzin", "Dizel", "Qaz", "Hibrid", "Elektro"] },
  { name: "gearbox", label: "Sürətlər qutusu", type: "select", options: ["Mexaniki", "Avtomat", "Robot", "Variator"] },
  { name: "body", label: "Ban növü", type: "select", options: ["Sedan", "Hetçbek", "Universal", "Offroader / SUV", "Kupe", "Minivan", "Pikap", "Furqon"] },
  { name: "condition", label: "Vəziyyət", type: "select", options: vehicleConditions },
];

const motoBrandList = [
  "Honda", "Yamaha", "Suzuki", "Kawasaki", "BMW", "KTM", "Harley-Davidson",
  "Ducati", "Bajaj", "Racer", "Digər",
];

const motoFields: SpecField[] = [
  { name: "make", label: "Marka", type: "select", options: motoBrandList },
  { name: "model", label: "Model", type: "text", placeholder: "Məs: CBR 600" },
  { name: "year", label: "Buraxılış ili", type: "select", options: years },
  { name: "mileage", label: "Yürüş", type: "number", placeholder: "Məs: 12000", suffix: "km" },
  { name: "engine", label: "Mühərrik həcmi", type: "number", placeholder: "Məs: 600", suffix: "sm³" },
  { name: "condition", label: "Vəziyyət", type: "select", options: vehicleConditions },
];

const twoWheelerFields: SpecField[] = [
  { name: "type", label: "Nəqliyyat növü", type: "select", options: ["Skuter", "Motosiklet", "Moped", "Elektrik skuter", "Elektrik moped", "Digər"] },
  { name: "make", label: "Marka", type: "select", options: motoBrandList },
  { name: "model", label: "Model", type: "text", placeholder: "Məs: Honda PCX 150" },
  { name: "year", label: "Buraxılış ili", type: "select", options: years },
  { name: "mileage", label: "Yürüş", type: "number", placeholder: "Məs: 8000", suffix: "km" },
  { name: "engine", label: "Mühərrik həcmi", type: "number", placeholder: "Məs: 150", suffix: "sm³" },
  { name: "condition", label: "Vəziyyət", type: "select", options: vehicleConditions },
];

const genericFields: SpecField[] = [
  { name: "brand", label: "Marka", type: "text", placeholder: "Marka (istəyə bağlı)" },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

const applianceTypeOptions = [
  "Soyuducu", "Paltaryuyan maşın", "Qabyuyan maşın", "Kondisioner", "Televizor",
  "Mikrodalğalı soba", "Soba / Bişirmə paneli", "Tozsoran", "Ütü", "Blender",
  "Mikser", "Çaydan", "Kombi / Su qızdırıcısı", "Dondurucu", "Digər",
];

const applianceFields: SpecField[] = [
  { name: "brand", label: "Marka", type: "text", placeholder: "Məs: Bosch, LG, Samsung" },
  { name: "appliance_type", label: "Texnika növü", type: "select", options: applianceTypeOptions },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
  { name: "warranty", label: "Zəmanət", type: "select", options: ["Var", "Yoxdur", "Bitmiş"] },
  { name: "energy_class", label: "Enerji sinfi", type: "select", options: ["A+++", "A++", "A+", "A", "B", "C", "Digər"] },
];

const computerFields: SpecField[] = [
  { name: "device_type", label: "Texnika növü", type: "select", options: ["Noutbuk", "Stolüstü kompüter", "Planşet", "Monitor", "Printer / Skaner", "Şəbəkə avadanlığı", "Komplektedici", "Aksesuar", "Digər"] },
  { name: "brand", label: "Marka", type: "text", placeholder: "Məs: Apple, HP, Lenovo" },
  { name: "cpu", label: "Prosessor", type: "text", placeholder: "Məs: Intel Core i5 12400" },
  { name: "ram", label: "Operativ yaddaş (RAM)", type: "select", options: ["4 GB", "8 GB", "16 GB", "32 GB", "64 GB+"] },
  { name: "storage", label: "Yaddaş", type: "select", options: ["128 GB SSD", "256 GB SSD", "512 GB SSD", "1 TB SSD", "1 TB HDD", "2 TB+", "Digər"] },
  { name: "screen", label: "Ekran ölçüsü", type: "text", placeholder: "Məs: 15.6\"" },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
  { name: "warranty", label: "Zəmanət", type: "select", options: ["Var", "Yoxdur", "Bitmiş"] },
];

const gardenFields: SpecField[] = [
  { name: "garden_type", label: "Məhsul növü", type: "select", options: ["Toxum və tinglər", "Bitki və güllər", "Gübrə və dərmanlar", "Bağ alətləri", "Suvarma sistemləri", "İstixana və örtüklər", "Bağ mebeli", "Texnika (ot biçən, motoblok)", "Digər"] },
  { name: "brand", label: "Marka", type: "text", placeholder: "İstəyə bağlı" },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

const constructionFields: SpecField[] = [
  { name: "material_type", label: "Növ", type: "select", options: ["Tikinti materialları", "Santexnika", "Elektrik malları", "Boya və laklar", "Qapı və pəncərələr", "Döşəmə və kafel", "Alət və avadanlıq", "Təmir xidməti", "Digər"] },
  { name: "brand", label: "Marka", type: "text", placeholder: "İstəyə bağlı" },
  { name: "unit", label: "Ölçü vahidi", type: "select", options: ["ədəd", "m²", "m³", "metr", "kq", "ton", "qab / kisə"] },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

const personalFields: SpecField[] = [
  { name: "item_type", label: "Əşya növü", type: "select", options: ["Çanta və pulqabı", "Şəxsi baxım", "Eynək və saat", "Çamadan və səyahət", "Tibbi mallar", "Digər"] },
  { name: "brand", label: "Marka", type: "text", placeholder: "İstəyə bağlı" },
  { name: "gender", label: "Cins", type: "select", options: ["Kişi", "Qadın", "Uniseks", "Uşaq"] },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

const bookFields: SpecField[] = [
  { name: "book_type", label: "Növ", type: "select", options: ["Bədii ədəbiyyat", "Dərslik", "Uşaq kitabı", "Xarici dil vəsaiti", "Qırtasiyyə", "Kurs / Repetitor", "Digər"] },
  { name: "language", label: "Dil", type: "select", options: ["Azərbaycan", "Rus", "İngilis", "Türk", "Digər"] },
  { name: "author", label: "Müəllif", type: "text", placeholder: "İstəyə bağlı" },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

const hobbyFields: SpecField[] = [
  { name: "hobby_type", label: "Növ", type: "select", options: ["Musiqi alətləri", "Antikvariat", "Numizmatika / Filateliya", "Əl işləri", "Rəsm və sənət", "Ovçuluq və balıqçılıq", "Stolüstü oyunlar", "Digər"] },
  { name: "brand", label: "Marka / Müəllif", type: "text", placeholder: "İstəyə bağlı" },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

const freeFields: SpecField[] = [
  { name: "free_type", label: "Növ", type: "select", options: ["Pulsuz verilir", "Dəyişdirilir (barter)", "İtmiş", "Tapılmış", "Könüllü kömək"] },
  { name: "pickup", label: "Təhvil üsulu", type: "select", options: ["Ünvandan götürmə", "Çatdırılma var", "Razılaşma ilə"] },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

const clothingFields: SpecField[] = [
  { name: "brand", label: "Marka", type: "text", placeholder: "İstəyə bağlı" },
  { name: "gender", label: "Kimin üçün", type: "select", options: ["Kişi", "Qadın", "Uniseks", "Uşaq"] },
  { name: "size", label: "Ölçü", type: "select", options: ["XS", "S", "M", "L", "XL", "XXL", "3XL", "Digər"] },
  { name: "color", label: "Rəng", type: "select", options: ["Qara", "Ağ", "Boz", "Mavi", "Yaşıl", "Qırmızı", "Bej", "Çəhrayı", "Digər"] },
  { name: "condition", label: "Vəziyyət", type: "select", options: conditions },
];

/** Bütün kateqoriyalarda göstərilən "elanın növü" seçimi. */
export const DEAL_TYPE_FIELD = "listing_kind";

const dealTypeField: SpecField = {
  name: DEAL_TYPE_FIELD,
  label: "Elanın növü",
  type: "select",
  options: ["Satılır", "Alınır", "Kirayə verilir", "Kirayə götürülür", "Xidmət göstərilir", "Dəyişdirilir", "Pulsuz verilir"],
};

/** İş elanları üçün sahələr. */
export const JOB_KIND_FIELD = "job_kind";

/** İş elanları kateqoriyaları. */
export const HOTEL_PROFESSION = "Otel Vakansiyaları";
export const SALON_PROFESSION = "Gözəllik Salonu Vakansiyaları";

export const PROFESSIONS = [
  "Ofis işləri", "Satış", "Market və Kassir", "Restoran və Kafe", "Sürücü",
  "Taksi", "Kuryer", "Anbar", "Tikinti", "Mühafizə", "Təmizlik", "Dayə",
  "Yaşlı baxıcısı", "Uşaq baxıcısı", "Aşpaz", "Ofisiant", "Barista", "Bərbər",
  "Kosmetoloq", "Masaj xidmətləri", HOTEL_PROFESSION, SALON_PROFESSION,
  "İT və Proqramlaşdırma", "Dizayn",
  "Mühasibat", "Təhsil", "Tibb", "Digər",
];

/** Otel vakansiyaları — vəzifələr. */
export const HOTEL_ROLES = [
  "Resepsion", "Xadimə", "Otaq təmizləyicisi", "Bellboy", "Aşpaz",
  "Aşpaz köməkçisi", "Ofisiant", "Barista", "Qabyuyan", "Təhlükəsizlik",
  "Menecer",
];

/** Gözəllik salonu vakansiyaları — vəzifələr. */
export const SALON_ROLES = [
  "Bərbər", "Kişi bərbəri", "Qadın saç ustası", "Manikür ustası",
  "Pedikür ustası", "Vizajist", "Kosmetoloq", "Kirpik ustası", "Qaş ustası",
  "Masaj ustası", "SPA mütəxəssisi", "Administrator",
];

/** Masaj xidmətləri. */
export const MASSAGE_SERVICES = [
  "Spa", "Sauna", "Hamam", "Cakuzi", "Buxar otağı", "Relaks mərkəzləri",
  "Klassik masaj", "Terapevtik masaj", "İdman masajı", "Aromaterapiya",
  "Ayaq masajı", "Masaj salonları", "Evə gəlməklə masaj", "Wellness xidmətləri",
];

const massageFields: SpecField[] = [
  { name: "service", label: "Xidmət növü", type: "select", options: MASSAGE_SERVICES },
  { name: "duration", label: "Seans müddəti", type: "select", options: ["30 dəqiqə", "45 dəqiqə", "60 dəqiqə", "90 dəqiqə", "120 dəqiqə"] },
  { name: "gender", label: "Kimlər üçün", type: "select", options: ["Qadınlar üçün", "Kişilər üçün", "Hamı üçün"] },
  { name: "place", label: "Xidmət yeri", type: "select", options: ["Salonda", "Evə gəlməklə", "Hər ikisi"] },
  { name: "address", label: "Ünvan", type: "text", placeholder: "Məs: Nəsimi r., Azadlıq pr. 24" },
  { name: "work_hours", label: "İş saatları", type: "text", placeholder: "Məs: 09:00 – 21:00, hər gün" },
];

/** Kosmetoloq xidmətləri. */
export const COSMETOLOGY_SERVICES = [
  "Üz baxımı", "Dəri təmizlənməsi", "Peeling", "Mezoterapiya", "Botoks",
  "Dolğu (Fillerlər)", "Lazer epilyasiya", "Qaş və Kiprik", "Makiyaj (Vizaj)",
  "Gözəllik prosedurları", "Digər kosmetoloji xidmətlər",
];

const cosmetologyFields: SpecField[] = [
  { name: "service", label: "Xidmət növü", type: "select", options: COSMETOLOGY_SERVICES },
  { name: "duration", label: "Prosedur müddəti", type: "select", options: ["15 dəqiqə", "30 dəqiqə", "45 dəqiqə", "60 dəqiqə", "90 dəqiqə"] },
  { name: "gender", label: "Kimlər üçün", type: "select", options: ["Qadınlar üçün", "Kişilər üçün", "Hamı üçün"] },
  { name: "place", label: "Xidmət yeri", type: "select", options: ["Salonda", "Evə gəlməklə", "Hər ikisi"] },
  { name: "address", label: "Ünvan", type: "text", placeholder: "Məs: Nəsimi r., Azadlıq pr. 24" },
  { name: "work_hours", label: "İş saatları", type: "text", placeholder: "Məs: 10:00 – 20:00, hər gün" },
];

const adFields: SpecField[] = [
  { name: "ad_type", label: "Reklamın növü", type: "select", options: ["Biznes reklamı", "Mağaza reklamı", "Xidmət reklamı", "Kampaniya / Endirim", "Banner reklamı", "Sosial media reklamı"] },
  { name: "company", label: "Biznes / Mağaza adı", type: "text", placeholder: "Məs: Albazar MMC" },
  { name: "website", label: "Sayt və ya sosial şəbəkə", type: "text", placeholder: "instagram.com/..." },
  { name: "address", label: "Ünvan", type: "text", placeholder: "Məs: Bakı, Nizami küç. 5" },
  { name: "work_hours", label: "İş saatları", type: "text", placeholder: "Məs: 10:00 – 19:00" },
  { name: "duration", label: "Reklam müddəti", type: "select", options: ["1 gün", "7 gün", "30 gün", "Daimi"] },
];

export const JOB_VACANCY = "Vakansiya (işçi axtarıram)";
export const JOB_SEEKER = "İş axtarıram";

const EXPERIENCE_LEVELS = ["Təcrübəsiz", "1 ilə qədər", "1-3 il", "3-5 il", "5 ildən çox"];
const EDUCATION_LEVELS = ["Fərqi yoxdur", "Orta", "Orta-ixtisas", "Ali", "Magistr"];
const SCHEDULES = ["Tam ştat", "Yarımştat", "Növbəli", "Uzaqdan (remote)", "Müvəqqəti"];

const vacancy = { field: JOB_KIND_FIELD, value: JOB_VACANCY } as const;
const seeker = { field: JOB_KIND_FIELD, value: JOB_SEEKER } as const;

const jobFields: SpecField[] = [
  { name: JOB_KIND_FIELD, label: "Elanın növü", type: "select", options: [JOB_VACANCY, JOB_SEEKER] },
  { name: "profession", label: "Kateqoriya", type: "select", options: PROFESSIONS },
  {
    name: "job_role",
    label: "Vəzifə",
    type: "select",
    dependsOn: "profession",
    optionsBy: { [HOTEL_PROFESSION]: HOTEL_ROLES, [SALON_PROFESSION]: SALON_ROLES },
  },

  // 1) İşəgötürən üçün
  { name: "company", label: "Şirkət adı (istəyə bağlı)", type: "text", placeholder: "Məs: Albazar MMC", showWhen: vacancy },
  { name: "position", label: "Vakansiya adı", type: "text", placeholder: "Məs: Satış meneceri", showWhen: vacancy },
  { name: "address", label: "İş yeri (rayon/ünvan)", type: "text", placeholder: "Məs: Nərimanov r., Atatürk pr. 12", showWhen: vacancy },
  { name: "salary_min", label: "Maaş (minimum)", type: "number", placeholder: "Məs: 700", suffix: "₼", showWhen: vacancy },
  { name: "salary_max", label: "Maaş (maksimum)", type: "number", placeholder: "Məs: 1200", suffix: "₼", showWhen: vacancy },
  { name: "salary", label: "Və ya maaş qeydi", type: "text", placeholder: "Məs: Razılaşma ilə", showWhen: vacancy },
  { name: "schedule", label: "İş qrafiki", type: "select", options: SCHEDULES, showWhen: vacancy },
  { name: "experience_required", label: "Təcrübə tələbi", type: "select", options: EXPERIENCE_LEVELS, showWhen: vacancy },
  { name: "education_required", label: "Təhsil", type: "select", options: EDUCATION_LEVELS, showWhen: vacancy },
  { name: "age_range", label: "Yaş tələbi (istəyə bağlı)", type: "text", placeholder: "Məs: 20–40 yaş", showWhen: vacancy },
  { name: "job_details", label: "İş barədə ətraflı məlumat", type: "textarea", placeholder: "İşin məzmunu, iş saatları, şərtlər...", full: true, showWhen: vacancy },
  { name: "requirements", label: "Namizədə tələblər", type: "textarea", placeholder: "Təcrübə, dil bilikləri, kompüter bacarıqları...", full: true, showWhen: vacancy },
  { name: "benefits", label: "Təklif olunan üstünlüklər", type: "textarea", placeholder: "Nahar, yol xərci, bonus, karyera imkanı...", full: true, showWhen: vacancy },
  { name: "email", label: "E-poçt (istəyə bağlı)", type: "text", placeholder: "info@sirket.az", showWhen: vacancy },
  { name: "logo_url", label: "Şirkət loqosu (istəyə bağlı)", type: "file", accept: "image/*", showWhen: vacancy },

  // 2) İş axtaran üçün
  { name: "full_name_seeker", label: "Ad və soyad", type: "text", placeholder: "Məs: Aysel Quliyeva", showWhen: seeker },
  { name: "desired_position", label: "Axtardığı vəzifə", type: "text", placeholder: "Məs: Mühasib", showWhen: seeker },
  { name: "age", label: "Yaş (istəyə bağlı)", type: "number", placeholder: "Məs: 27", showWhen: seeker },
  { name: "expected_salary", label: "Gözlədiyi maaş", type: "text", placeholder: "Məs: 800 ₼ və ya razılaşma ilə", showWhen: seeker },
  { name: "experience", label: "İş təcrübəsi", type: "select", options: EXPERIENCE_LEVELS, showWhen: seeker },
  { name: "education", label: "Təhsil", type: "select", options: EDUCATION_LEVELS, showWhen: seeker },
  { name: "skills", label: "Bacarıqlar", type: "textarea", placeholder: "Məs: MS Office, 1C, ingilis dili, sürücülük vəsiqəsi", full: true, showWhen: seeker },
  { name: "about", label: "Haqqında qısa məlumat", type: "textarea", placeholder: "Özünüz və iş təcrübəniz barədə qısa məlumat", full: true, showWhen: seeker },
  { name: "email_seeker", label: "E-poçt (istəyə bağlı)", type: "text", placeholder: "ad@mail.com", showWhen: seeker },
  { name: "cv_url", label: "CV yüklə (PDF/DOC)", type: "file", accept: ".pdf,.doc,.docx", showWhen: seeker },

  { name: "salary_period", label: "Əmək haqqı dövrü", type: "select", options: ["Aylıq", "Günlük", "Saatlıq", "İşin həcminə görə", "Razılaşma ilə"] },
];

export const isJobCategory = (category: string) => category === "is-elanlari";

/** Elan iş axtaran elanıdırmı (default: vakansiya). */
export const isJobSeeker = (specs: Record<string, string> | null | undefined) =>
  (specs?.[JOB_KIND_FIELD] ?? JOB_VACANCY) === JOB_SEEKER;

const bySlug: Record<string, SpecField[]> = {
  telefonlar: phoneFields,
  evler: realtyFields,
  menziller: realtyFields,
  baglar: realtyFields,
  ofisler: realtyFields,
  obyektler: realtyFields,
  masinlar: carFields,
  motosikletler: motoFields,
  "iki-tekerli-neqliyyat": twoWheelerFields,
  "is-elanlari": jobFields,
  masaj: massageFields,
  kosmetoloq: cosmetologyFields,
  reklam: adFields,
  elektronika: genericFields,
  "meiset-esyalari": genericFields,
  "meiset-texnikasi": applianceFields,
  "kompyuter-texnika": computerFields,
  "bag-bagciliq": gardenFields,
  "tikinti-temir": constructionFields,
  "sexsi-esyalar": personalFields,
  "kitab-tehsil": bookFields,
  "hobbi-kolleksiya": hobbyFields,
  pulsuz: freeFields,
  geyim: clothingFields,
  ayaqqabi: clothingFields,
  aksesuar: personalFields,
  mebel: genericFields,
  kosmetika: genericFields,
  "qizil-zinet": genericFields,
  heyvanlar: genericFields,
  "idman-eylence": genericFields,
  xidmetler: genericFields,
  "usaq-alemi": genericFields,
};

/** "Elanın növü" sahəsi tətbiq olunmayan kateqoriyalar. */
const noDealType = new Set([
  "is-elanlari", "pulsuz", "reklam",
  "evler", "menziller", "baglar", "ofisler", "obyektler",
]);

/** Seçilmiş kateqoriya üçün sahələr (yoxdursa boş massiv). */
export function specFieldsFor(category: string): SpecField[] {
  if (!category) return [];
  const fields = bySlug[category] ?? genericFields;
  if (noDealType.has(category)) return fields;
  return [dealTypeField, ...fields];
}

/** Xüsusiyyətləri "Etiket: dəyər" cütlərinə çevirir (göstərmək üçün). */
export function specEntries(category: string, specs: Record<string, string> | null | undefined) {
  if (!specs) return [];
  const fields = specFieldsFor(category);
  return fields
    .filter((f) => specs[f.name] && f.type !== "file")
    .map((f) => ({ label: f.label, value: `${specs[f.name]}${f.suffix ? ` ${f.suffix}` : ""}` }));
}

/** Kateqoriya üzrə marka filtri (telefon, maşın, motosiklet). */
export type BrandFilter = {
  /** specs içindəki sahə adı */
  field: string;
  brands: string[];
  models: Record<string, string[]>;
};

const motoBrands = motoBrandList;

export function brandFilterFor(category: string): BrandFilter | null {
  if (category === "telefonlar")
    return { field: "brand", brands: Object.keys(phoneModels), models: phoneModels };
  if (category === "masinlar")
    return { field: "make", brands: Object.keys(carModels), models: carModels };
  if (category === "motosikletler")
    return { field: "make", brands: motoBrands, models: {} };
  if (category === "iki-tekerli-neqliyyat")
    return { field: "make", brands: motoBrands, models: {} };
  return null;
}

/** Elan seçilmiş marka/modelə uyğundurmu (specs yoxdursa başlıq üzrə axtarır). */
export function matchesBrand(
  ad: { category: string; title: string; description?: string; specs?: Record<string, string> | null },
  brand: string,
  model?: string,
): boolean {
  const filter = brandFilterFor(ad.category);
  const hay = `${ad.title} ${ad.description ?? ""}`.toLowerCase();
  const check = (value: string, specKey: string) => {
    const v = value.toLowerCase();
    const specValue = filter ? (ad.specs?.[specKey] ?? "") : "";
    if (specValue) return specValue.toLowerCase() === v;
    return hay.includes(v);
  };
  if (brand && !check(brand, filter?.field ?? "brand")) return false;
  if (model && !check(model, "model")) return false;
  return true;
}

/** Kateqoriyaya uyğun vəziyyət seçimləri (yoxdursa boş massiv). */
export function conditionOptionsFor(category: string): string[] {
  const field = specFieldsFor(category).find((f) => f.name === "condition");
  return field?.options ?? [];
}

/** Kateqoriyaya uyğun qısa vəziyyət sözü (kart badge-ləri üçün). */
function conditionLabel(category: string, value: string): string {
  const vehicles = new Set(["masinlar", "motosikletler", "iki-tekerli-neqliyyat"]);
  const clothes = new Set(["geyim", "ayaqqabi"]);
  if (vehicles.has(category)) {
    if (value === "Az işlənmiş") return "Az sürülüb";
    if (value === "Qəzalı / Təmir tələb edir") return "Qəzalı";
  }
  if (clothes.has(category)) {
    if (value === "İşlənmiş") return "İstifadə olunmuş";
    if (value === "Az işlənmiş") return "Az geyinilmiş";
  }
  if (value === "Təmir tələb edir") return "Təmir tələb edir";
  return value;
}

/** Kartda göstəriləcək qısa xüsusiyyət sözləri (maksimum 3, kateqoriyaya uyğun). */
export function cardBadges(
  ad: { category: string; specs?: Record<string, string> | null },
  max = 3,
): string[] {
  const s = ad.specs ?? {};
  const out: string[] = [];
  const push = (v?: string | null, suffix = "") => {
    const value = (v ?? "").trim();
    if (value && !out.includes(value + suffix)) out.push(value + suffix);
  };

  if (s["condition"]) push(conditionLabel(ad.category, s["condition"]));

  switch (ad.category) {
    case "masinlar":
    case "motosikletler":
    case "iki-tekerli-neqliyyat":
      push(s["year"]);
      if (s["mileage"]) push(`${s["mileage"]} km`);
      push(s["type"]);
      break;
    case "telefonlar":
      push(s["memory"]);
      push(s["brand"]);
      break;
    case "evler":
    case "menziller":
    case "baglar":
    case "ofisler":
    case "obyektler":
      if (s["rooms"]) push(`${s["rooms"]} otaq`);
      if (s["area"]) push(`${s["area"]} m²`);
      push(s["deal_type"]);
      break;
    case "geyim":
    case "ayaqqabi":
      push(s["size"]);
      push(s["gender"]);
      break;
    case "meiset-texnikasi":
      push(s["appliance_type"]);
      if (s["warranty"] === "Var") push("Zəmanətli");
      break;
    case "kompyuter-texnika":
      push(s["device_type"]);
      push(s["ram"]);
      break;
    case "is-elanlari":
      push(s["job_kind"]);
      push(s["schedule"]);
      break;
    default:
      push(s["brand"]);
      push(s[DEAL_TYPE_FIELD]);
      break;
  }

  return out.slice(0, max);
}
